import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { SupportUsersModel } from '@models/support-users.model';

export const SupportUsersActions = createActionGroup({
  source: 'Support Users',
  events: {
    'Reset To Initial State': emptyProps(),

    'Load Support Users': emptyProps(),
    'Load Support Users Success': props<{ users: SupportUsersModel.SupportUserDocument[] }>(),
    'Load Support Users Fail': emptyProps(),

    'Set filters': props<{ filters: SupportUsersModel.Filters }>(),
    'Start Loading Support Users': emptyProps(),
    'Set Is Loading': props<{ isLoading: boolean }>(),
    'Reset List': emptyProps(),
  },
});